import React from "react";
import { Settings2, LayoutGrid, BarChart3, Cpu, Factory } from "lucide-react";
import Reveal from "../common/Reveal";

const STRATEGIES = [
  {
    icon: Settings2,
    title: "고객 맞춤형 솔루션",
    desc: "제조 데이터를 기반으로 생산·품질·설비 관리 시스템을 최적화하여 스마트 제조 환경을 구축합니다.",
  },
  {
    icon: LayoutGrid,
    title: "제조업에 특화된 통합 플랫폼",
    desc: "실시간 데이터 수집, 공정 모니터링, 품질 관리 자동화로 효율적인 스마트공장을 지원합니다.",
  },
  {
    icon: BarChart3,
    title: "빅데이터 기반 데이터 분석",
    desc: "제조 데이터를 분석하여 불량 원인을 파악하고, 설비 운영 효율과 생산성 향상을 지원합니다.",
  },
  {
    icon: Cpu,
    title: "AI 기반 제조혁신",
    desc: "AI를 활용한 품질 판정, 이상 탐지, 예측 분석 및 공정 최적화를 통해 제조 현장의 지능화를 지원합니다.",
  },
  {
    icon: Factory,
    title: "스마트 제조 인프라 제공",
    desc: "MES 솔루션과 함께 장비 임대 및 OEM 공정 지원으로 제조 경쟁력을 극대화합니다.",
  },
];

const FeatureGrid = () => {
  return (
    <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {STRATEGIES.map(({ icon: Icon, title, desc }, index) => (
          <Reveal key={title} delay={index * 80}>
            <div className="group h-full rounded-xl border border-gray-100 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-100 hover:shadow-xl">
              <div className="inline-flex items-center justify-center rounded-lg bg-primary-50 p-3 transition-colors duration-300 group-hover:bg-primary-800">
                <Icon
                  className="h-6 w-6 text-primary-700 transition-colors duration-300 group-hover:text-white"
                  strokeWidth={1.75}
                />
              </div>
              <h3 className="mt-4 break-keep text-lg font-semibold text-primary-900">
                {title}
              </h3>
              <p className="mt-2 break-keep text-sm leading-relaxed text-gray-600">
                {desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  );
};

export default FeatureGrid;
